export const SN_PICKLIST = 'picklist'
export const PICKLISTS_UPDATED = SN_PICKLIST + '/UPDATED'
export const PICKLISTS_COMPLETED_UPDATED = SN_PICKLIST + '/COMPLETED'
export const PICKLIST_CURRENT_UPDATED = SN_PICKLIST + '/CURRENT_UPDATED'
export const PICKLIST_FILTERS_UPDATED = SN_PICKLIST + '/FILTERS_UPDATED'
export const PICKLIST_LAST_SCANNED_ID_UPDATED = SN_PICKLIST + '/LAST_SCANNED_ID_UPDATED'
export const PICKLIST_DETAILS_UPDATED = 'PICKLIST_DETAILS_UPDATED'
